// extracted by mini-css-extract-plugin
export default {"imgdiv":"_4c5a0894f6 _461e7e471a","img":"_52f27f1dff _1151c38ff3"};